import { forwardRef, ReactNode, LegacyRef } from 'react';
import cx from 'classnames/bind';

import Points from '../Points/Points';

import styles from './Hint.module.scss';

interface HintProps {
  children: string | ReactNode;
  className?: string;
  points?: number;
  receivedPoints?: number;
}

const cn = cx.bind(styles);

const Hint = forwardRef(
  (
    { children, className, points, receivedPoints }: HintProps,
    ref?: LegacyRef<HTMLDivElement>,
  ) =>
    points !== undefined ? (
      <div ref={ref} className={cn('hint', 'hint-points', className)}>
        {children}
        <Points points={points} receivedPoints={receivedPoints} />
      </div>
    ) : (
      <div ref={ref} className={cn('hint', className)}>
        {children}
      </div>
    ),
);

export default Hint;
